import qs from 'qs';
import { createBrowserHistory } from 'history';
import { observable } from 'mobx';
import { Rest, ModelStore } from '@smartplatform/model-store';
import { RouteStore } from '@smartplatform/route-store';
import { LocalStore } from '@smartplatform/local-store';
import UIStore from './uiStore';

/**
 * Глобальный контейнер сторов
 */
export class AppStore {
	local; // Локальное хранилище
	model; // Хранилище моделей
	route; // Хранилище маршрута браузера
	api; // API обмена с сервером
	admin; // Хранилище @admin
	ui; // ui
	recentPlenarySessions = null;

	adminPath = '/admin';

	constructor() {
		this.history = createBrowserHistory();
		this.local = new LocalStore();
		this.ui = new UIStore();

		this.rest = new Rest();
		this.model = new ModelStore({
			transport: this.rest,
			cache: true,
			autoConnect: false,
		});

		this.route = new RouteStore({
			history: this.history,
			decode: qs.parse,
			encode: qs.stringify,
		});

		this.local.extend({
			expandPages: false,
			expandPagesInside: false,
			gotoListAfterSave: true,
		});
		this.local.save();
	}

	init = async () => {
		await this.model.connect();
		this.recentPlenarySessions = await this.model.PlenarySession.find({ order: 'date desc', limit: 3 });
	};
}

window.APP_STORE = new AppStore();

export default window.APP_STORE;
